var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 58,
    viewBox: "0 0 130 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 130 0)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 100 24)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 130 24)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 100 48)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 70 48)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 130 48)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 70 0)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 40 24)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 10 48)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 100 0)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 70 24)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 40 48)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.92ded33118889a1db5ae6c35e876ecf0.svg";
export { ForwardRef as ReactComponent };